import React from "react";
import { Container, Row } from "reactstrap";
import RightSideContent from "./RightSideContent";
import Section from "./Section";

const MyProfile = () => {
  document.title = "Thông tin cv";
  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container fluid>
          <Row>
            <RightSideContent />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default MyProfile;
